'use client'

import urlWithQueryParams from '@lib/routes/helpers/urlWithQueryParams'
import PatientRoutes from '@lib/routes/PatientRoutes'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import { useRouter, useSearchParams } from 'next/navigation'
import { useState } from 'react'
import TrialApplySubmitButton from './TrialApplySubmitButton.client'

export default function TrialApplyStartButton({ slug }: { slug: string }) {
  const router = useRouter()
  const searchParams = useSearchParams()
  const params = Object.fromEntries(
    new URLSearchParams(searchParams?.toString()).entries(),
  )
  const [isLoading, setIsLoading] = useState(false)

  const handleStartButtonClick = () => {
    setIsLoading(true)
    trackEvent(TrackingEvents.TRIAL_APPLICATION_START_BUTTON_CLICKED, {
      source: TrackingSources.APPLY_FLOW_V2,
      trialSlug: slug,
      val: slug,
    })
    router.push(
      urlWithQueryParams(
        PatientRoutes.trialApplyPatient(slug),
        params,
      ).toString(),
    )
  }

  return (
    <TrialApplySubmitButton
      isLoading={isLoading}
      onClick={() => {
        handleStartButtonClick()
      }}
    />
  )
}
